var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor"},[_c('vue-ueditor-wrap',{attrs:{"config":_vm.editorConfig,"editor-id":"editorInch"},on:{"before-init":_vm.addCustomButton},model:{value:(_vm.msg),callback:function ($$v) {_vm.msg=$$v},expression:"msg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }